// @systeme: usage-runtime
// ============================================================================
// Compteur d'usage des pages — détection de code mort FONCTIONNEL
// ============================================================================
// cf. docs/CONSOLIDATION.md (P5). Envoie des PATTERNS de pathname normalisés
// (jamais d'URL brute : segments UUID → :id, numériques → :n, tokens →
// :token), batchés toutes les 30 s vers POST /api/usage/page. Best-effort et
// silencieux : ne doit jamais gêner l'UX ni générer d'erreur visible.
// Ne trace que les utilisateurs connectés (l'endpoint est authentifié) ; les
// pages publiques à token sont couvertes côté serveur par leurs routes API.
// ============================================================================

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const SEG_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function normaliserPathname(pathname: string): string {
  const normalise = pathname
    .split("/")
    .map((seg) => {
      if (!seg) return seg;
      if (SEG_UUID.test(seg)) return ":id";
      if (/^\d+$/.test(seg)) return ":n";
      if (seg.length >= 22 && /^[A-Za-z0-9_-]+$/.test(seg)) return ":token";
      return seg;
    })
    .join("/");
  return normalise || "/";
}

export default function PageUsageTracker() {
  const tampon = useRef<Set<string>>(new Set());
  const location = useLocation();

  useEffect(() => {
    tampon.current.add(normaliserPathname(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    const flush = () => {
      if (tampon.current.size === 0) return;
      // Ne tracer que les utilisateurs connectés (endpoint authentifié). Un
      // visiteur anonyme (catalogue public) n'a pas de token : on vide le tampon
      // sans appeler l'API — évite un 401 inutile toutes les 30 s.
      if (!localStorage.getItem("token")) {
        tampon.current.clear();
        return;
      }
      const patterns = [...tampon.current].slice(0, 50);
      tampon.current.clear();
      // skipAuthRedirect : une télémétrie de fond ne doit JAMAIS provoquer de
      // navigation, même si le token a expiré entre-temps.
      api.post("/usage/page", { patterns }, { skipAuthRedirect: true }).catch(() => {
        // silencieux : non connecté ou réseau — la collecte est best-effort
      });
    };
    const timer = window.setInterval(flush, 30_000);
    return () => {
      window.clearInterval(timer);
      flush();
    };
  }, []);

  return null;
}
